<template>
  <panel>
    <div class="title">
      <h2>{{ $t('home.jewelHistories') }}</h2>
      <div class="button">
        <enlil-button @click="fetch" :disabled="!isLoggedIn || isFetching">
          <span v-if="isFetching"><loading-wheel/></span>
          <span v-else>{{ $t('home.jewelHistoryTable.refresh') }}</span>
        </enlil-button>
      </div>
    </div>
    <p v-if="isFetching" class="loading">{{ $t('home.jewelHistoryTable.loading') }}</p>
    <div v-if="isFetched && !isError && hasAnyHistory">
      <jewel-history-list-item
        v-for="history in histories"
        :key="`${history.type}-${history.id}`"
        :difference="history.difference"
        :type="history.type"
        :calculationForDate="history.calculationForDate"
        :exchangedAt="history.exchangedAt"
        :datetime="history.datetime"/>
    </div>
    <p v-if="isFetched && !isError && !hasAnyHistory">{{ $t('home.jewelHistoryTable.noHistories') }}</p>
    <p v-if="isFetched && isError" class="error">{{ $t('home.jewelHistoryTable.error') }}</p>
  </panel>
</template>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .button {
    font-size: 0.7em;
  }
}

.loading {
  font-size: 0.8em;
  color: #999;
}

.error {
  font-size: 0.8em;
  color: #990000;
}
</style>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import EnlilButton from '../../../components/EnlilButton.vue'
import LoadingWheel from '../../../components/LoadingWheel.vue'
import Panel from '../../../components/Panel.vue'
import JewelHistoryListItem from './JewelHistoryListItem.vue'

export default {
  name: 'jewel-history-panel',
  components: {
    EnlilButton,
    LoadingWheel,
    Panel,
    JewelHistoryListItem
  },
  async mounted () {
    if (this.isLoggedIn && !this.isFetched && !this.isFetching) {
      await this.fetch()
    }
  },
  computed: {
    ...mapGetters('session', ['isLoggedIn']),
    ...mapState('jewelHistories', ['isFetching', 'isFetched', 'isError', 'histories']),
    hasAnyHistory () {
      return this.histories.length > 0
    }
  },
  methods: {
    ...mapActions('jewelHistories', ['fetch'])
  }
}
</script>
